import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export default function ReelsCarousel({ reels }) {
  const scrollRef = useRef(null);
  const items = reels || [];
  if (!items.length) return null;
  return (
    <section data-testid="reels-carousel" className="py-16 md:py-28 border-t border-[color:var(--border)]">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between mb-10 md:mb-16">
          <div>
            <div className="eyebrow mb-3">Motion</div>
            <h2 className="font-display italic text-4xl md:text-6xl leading-[1] tracking-tight">Selected Reels</h2>
          </div>
          <Link to="/reels" data-testid="reels-see-all" className="eyebrow link-underline">All Reels →</Link>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex gap-4 md:gap-6 overflow-x-auto snap-x-mandatory hide-scrollbar px-5 md:px-10 pb-4"
      >
        {items.map((r) => (
          <Link
            key={r.id}
            to="/reels"
            data-testid={`reel-card-${r.id}`}
            className="relative snap-start flex-shrink-0 w-[72vw] md:w-[320px] aspect-[9/16] hover-scale bg-[color:var(--surface)]"
          >
            <img src={r.thumbnail_url || r.video_url} alt={r.title} loading="lazy" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute top-4 left-4 w-10 h-10 rounded-full bg-[color:var(--text)]/90 flex items-center justify-center">
              <Play size={16} className="text-[color:var(--bg)] ml-0.5" fill="currentColor" />
            </div>
            <div className="absolute bottom-4 left-4 right-4">
              <div className="font-display italic text-xl leading-tight">{r.title}</div>
              {r.caption && <div className="mt-1 text-xs text-[color:var(--text-muted)] line-clamp-2">{r.caption}</div>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
